import axios from "axios";
import { silentHTTPCaller, toastWrapper } from "../utils/toastWrapper";
import { appDispatch } from "../app/store";
import { setAppConfig, setProduct, setShowVerificationPending } from "../app/slice/authSlice";
import { getAppId, getIDBaseURL } from "../utils/getBaseURL";

const url = getIDBaseURL();
const appId = getAppId()

export const getAuthOTP = (data: { emailAddress: string }, handleDone, handleError?) => {
  const call = axios.post(`${url}Otp/email`, data, {
    headers: {
      ApplicationId: appId || ''
    }
  })
  toastWrapper(
    call,
    'Validating your email...',
    (resp) => {
      handleDone();
      return resp.data.message || 'OTP sent to the provided email!';
    },
    'Error validating email!',
    (err) => {
      // @ts-ignore
      return err?.response?.data?.message || 'Error validating email';
    },
    () => {
      handleError && handleError();
    })
}

export const registerBusiness = (data: Record<string, any>, handleDone) => {
  const call = axios.post(`${url}Onboarding/register`, data, {
    headers: {
      ApplicationId: appId || ''
    }
  })
  toastWrapper(call, 'Registering your business...', (resp) => {
    handleDone();
    return resp.data.message || 'Login details sent to your provided email address!';
  }, 'Error registering business!');
}

export const getAppConfig = (id: string, handleDone) => {
  const call = axios.get(`${url}configuration/security/options/${id}`, {
    headers: {
      ApplicationId: appId || ''
    }
  })
  silentHTTPCaller(call, 'Getting security options...', (resp) => {
    handleDone(resp.data);
    appDispatch(setAppConfig(resp.data.data))
    return resp.data.message || 'Options loaded';
  }, 'Error loading security options!');
}

export const updateAppConfig = (data: Record<string, any>, id: string, handleDone) => {
  const call = axios.post(`${url}configuration/security/update/${id}`, data, {
    headers: {
      ApplicationId: appId || ''
    }
  })
  toastWrapper(call, 'Updating your settings...', (resp) => {
    handleDone();
    return resp.data.message || 'Settings saved successfully';
  }, 'Error saving settings!');
}

export const showVerificationPending = () => {
  appDispatch(setShowVerificationPending(true));
}

export const setSelectedProduct = (product: Record<string, string>) => {
  appDispatch(setProduct(product));
}


export const verifyEmployerCode = async (code: string, handleDone, handleError) => {
  //  /api/v1/Onboarding/verify/emp/{code}
  const call = axios.get(`${url}Onboarding/verify/emp/${code}`, {
    headers: {
      ApplicationId: appId || ''
    }
  })

  try {
    const resp = await call;
    handleDone(resp.data);
  } catch (error) {
    handleError && handleError();
  }
}